/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useRef, useState } from "react";
import { NavLink } from "react-router-dom";
import { empty, errorResponse, isArray, prepareResponseData } from "../../Utilities/utils";
import { AuthContext } from "../Root/ProtectedRoute";
import { Toast } from "primereact/toast";
import { FaPlus } from "react-icons/fa";

// css
import "../students/Students.css";

// api
import paymentApi from "../../api/Payment";

//components
import MainHeader from "../../components/headers/mainHeader/MainHeader";
import TableLoading from "../../components/skeleton/TableLoading";
import FullPageLoader from "../../components/loader/FullPageLoader";
import colors from "../../config/colors";
import ButtonIcon from "../../components/buttons/buttonIcon/ButtonIcon";
import PaymentWrapper from "../../components/appWrapper/PaymentWrapper";
import PaymentTable from "../../components/tables/primeTable/finance/PaymentTable";

const PaymentHistory = ({ ...props }) => {
  const { user } = useContext(AuthContext);
  //ref
  const toastTR = useRef(null);
  // states
  const [searchValue, setSearchValue] = useState("");
  const [filterValue, setFilterValue] = useState("");
  const [paymentHistories, setPaymentHistoriesData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(50);
  const [search, setSearch] = useState("");

  //alert functions
  const responseDialog = (severity = null, summary = null, detail = null) => {
    toastTR?.current?.show({
      severity,
      summary,
      detail,
      life: 8000,
    });
  };

  useEffect(() => {
    if (filterValue?.toLowerCase() === 'completed' || filterValue?.toLowerCase() === 'pending' || filterValue?.toLowerCase() === 'cancelled') {
      getPaymentHistories();
    }
  }, [filterValue])

  useEffect(() => {
    try {
      getPaymentHistories();
    } catch (error) {
      responseDialog(
        "error",
        "Something went wrong",
        "Failed to load payment histories. Please try again later."
      );
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ user?._id, first, rows, searchValue ]);

  // function to get all payment histories
  const getPaymentHistories = async () => {
    try {
      if (!isLoading) setIsLoading(true);
      const page = first / rows;
      const response = await paymentApi.getPaymentHistories(
        page,
        rows,
        searchValue,
        filterValue,
      );
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.success) {
        return setPaymentHistoriesData([]);
      } 
      const results = isArray(response_data.response)
          ? response_data.response
          : [];
      setPaymentHistoriesData(results);
      setTotalRecords(!empty(response_data.count) ? response_data.count : 0);
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setIsLoading(false);
    }
  };

  const onKeyDown = (event) => {
    if (event.key === "Enter") {
      setSearchValue(event.target.value);
      setFirst(0);
    }
  };

  const onSearchChange = (event) => {
    setSearch(event.target.value);
  };

  const onPageChange = (event) => {
    setFirst(event.first);
    setRows(event.rows);
  };

  // filter search 
  const filterSearch = (value) => {
    setFilterValue(value);
  }
  
  return (
    <>
      <PaymentWrapper {...props}>
        <main>
          <div className="tableCard">
            {/*  header start */}
            <MainHeader
              button={true}
              multiButtons={
                <NavLink to="/finance/payment/add" style={{ textDecoration: "none" }}>
                  <ButtonIcon
                    borderColor={colors.primary}
                    backgroundColor={colors.primary}
                    color={colors.white}
                    buttonText="Add Payment"
                    marginRight={1}
                    iconMarginRight={5}
                    icon={<FaPlus />}
                    width={140}
                    height={30}
                    marginBottom={2}
                  />
                </NavLink>
              }
              title="Payment History"
            />
            {/* end of header */}

            {/* table start */}
            {!isLoading ? (
              <PaymentTable
                paymentHistories={paymentHistories}
                onPageChange={onPageChange}
                rows={rows}
                totalRecords={totalRecords}
                first={first}
                search={search}
                onKeyDown={onKeyDown}
                onSearchChange={onSearchChange}
                filterValue={filterValue?.toLowerCase() === 'completed' ? 1 : filterValue?.toLowerCase() === 'cancelled' ? 2 : filterValue?.toLowerCase() === 'pending' ? 3 : 1}
                filterSearch={filterSearch}
                currency={user?.currency?.currency_symbol || ''}
              />
            ) : (
              <TableLoading rows={50} cols={7} header={false} />
            )}
            {/* table end  */}
          </div>
        </main>
        {isLoading && <FullPageLoader visible={isLoading} />}
      </PaymentWrapper>

      <Toast ref={toastTR} style={{ zIndex: 99999 }} position="bottom-left" />
    </>
  );
};

export default PaymentHistory;
